import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { socialLinksApi } from "./api";
import type { SocialLink, SocialLinkInput } from "./types";

export const socialLinkKeys = {
  all: ["social-links"] as const,
  public: ["social-links", "public"] as const,
};

export function usePublicSocialLinks() {
  return useQuery({
    queryKey: socialLinkKeys.public,
    queryFn: socialLinksApi.publicList,
  });
}

export function useSocialLinks() {
  return useQuery({
    queryKey: socialLinkKeys.all,
    queryFn: socialLinksApi.list,
  });
}

export function useCreateSocialLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: socialLinksApi.create,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: socialLinkKeys.all }),
  });
}

export function useUpdateSocialLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ link, input }: { link: SocialLink; input: SocialLinkInput }) => socialLinksApi.update(link.id, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: socialLinkKeys.all }),
  });
}

export function useDeleteSocialLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: socialLinksApi.delete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: socialLinkKeys.all }),
  });
}
